import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleCheck } from 'lucide-react';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { InstitutionFuturesProgressStep } from '@/context/progress';
import FuturesAppropriatenessTestLayout from '@/features/futures/layouts/appropriateness-test';

const InstitutionFuturesAppropriatenessTestResultPassedPage = (props: ComponentProps<typeof FuturesAppropriatenessTestLayout>) => {
  const { t } = useTranslation();

  return (
    <FuturesAppropriatenessTestLayout className="-md:justify-center space-y-8" progress={1} size="sm" step={InstitutionFuturesProgressStep.APPROPRIATENESS_TEST} {...props}>
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleCheck />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('institutionOnboardingProgress.futures.complete.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('institutionOnboardingProgress.futures.complete.description')}</PageHeadingDescription>
        <PageHeadingDescription>{t('institutionOnboardingProgress.futures.complete.goToExchange')}</PageHeadingDescription>
      </PageHeading>
      <Button size="lg" variant="primary" asChild>
        <a href={import.meta.env.VITE_APP_EXCHANGE_URL}>{t('buttons.exchange')}</a>
      </Button>
    </FuturesAppropriatenessTestLayout>
  );
};
InstitutionFuturesAppropriatenessTestResultPassedPage.displayName = 'InstitutionFuturesAppropriatenessTestResultPassedPage';

export default InstitutionFuturesAppropriatenessTestResultPassedPage;
